import type { APIErrorModel } from "$lib/models/APIErrorModel";
import type { HTTPError } from "ky";

/**
 * Extracts the `errorDetails` array from erroneous HTTP calls 
 */
export const errorDetailsExtractor = async (errorResponse: HTTPError["response"] | undefined): Promise<string> => {
    if (errorResponse) {
        const errorDetails: APIErrorModel = await errorResponse.json();
        return errorDetails.errorDetails.join(". ");
    } else {
        return "En feil oppstod";
    }
}